import useRwd from '../utils/useRwd'

export default function MainLayout({ children, ...props }) {
  const { isPhone } = useRwd()
  const { bannerFile, bannerAlt } = props
  return (
    <div style={{ width: '100%' }}>
      <div>
        <img src={bannerFile} alt={bannerAlt} style={{ width: '100%' }} />
      </div>
      <div
        style={{
          width: isPhone ? '80%' : '70%',
          margin: 'auto',
          marginTop: '5em',
        }}
      >
        {children}
      </div>
    </div>
  )
}
